export default {
  '&FormError.ErrorMessage': 'Something Went Wrong',
  '&FormError.Retry': 'Retry',
} as TextDictionary;
